// /api/login.js

import axios from 'axios'
import qs from 'qs'
import baseURL from './config'

const Base64 = require('js-base64').Base64
axios.defaults.baseURL = baseURL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'

// axios 请求拦截
axios.interceptors.request.use(function (response) {
    // 在 headers 中设置authorization 属性放token，token是存在缓存中的
    var Jwt = localStorage.getItem('token')
    if (typeof Jwt === 'string') {
        try {
            var o_jwt = JSON.parse(Jwt)
            if (typeof o_jwt === 'object' && o_jwt) {
                if (o_jwt.value) {
                    response.headers.Authorization = o_jwt.value
                } else {
                    response.headers.Authorization = null
                }
            }
        } catch (e) {
            console.log(e)
        }
    }
    return response
}, function (error) {
    return Promise.reject(error)
})

// axios 响应拦截器
axios.interceptors.response.use(function (response) {
    var error = response.data.error
    if (parseInt(error) === 0) {
        // 区分登录 、登出 、验证
        switch (response.data.data.action) {
            // 1) 登录
            case 'login':
                var token = response.data.data.token
                var userid = response.data.data.userid
                var username = response.data.data.username
                var userheader = response.data.data.userheader
                var usercode = response.data.data.nationcode
                var userarea = response.data.data.userarea
                localStorage.setItem('token', JSON.stringify(token))
                localStorage.setItem('userid', userid)
                localStorage.setItem('username', username)
                localStorage.setItem('userheader', userheader)
                localStorage.setItem('usercode', usercode)
                localStorage.setItem('userarea', userarea)
                localStorage.setItem('fileShareShow', response.data.data.fileShareShow)
                break
            case 'logout':
                localStorage.removeItem('token')
                localStorage.removeItem('userid')
                localStorage.removeItem('username')
                localStorage.removeItem('userheader')
                localStorage.removeItem('usercode')
                localStorage.removeItem('userarea')
                localStorage.removeItem('fileShareShow')
                break
            case 'valilogin':
                break
        }
    }
    return response
}, function (error) {
    return Promise.reject(error)
})

// 登录的接口
export const loginIn = async function (params) {
    const postData = {
        username: params.username,
        password: params.password,
        nationcode: isNaN(params.nationcode) ? '86' : params.nationcode,
        account: params.account
    }
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
                '/?r=v1/login/login-in', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 退出登录
export const loginOut = async function (user) {
    const Jwt = JSON.parse(localStorage.getItem('token'))
    const token = Jwt.value
    const postData = {
        username: user,
        token: token
    }
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
                '/?r=v1/login/login-out', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 验证是否登录的接口
export const valiLogin = async function (user, nationcode) {
    var Jwt = null
    var token = null
    try {
        Jwt = JSON.parse(localStorage.getItem('token'))
    } catch (e) {
        console.log(e)
    }
    if (Jwt !== null && Jwt.value) {
        token = Jwt.value
    } else {
        return false
    }
    const postData = {
        username: user,
        nationcode: isNaN(nationcode) ? 86 : nationcode,
        token: token
    }
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
                '/?r=v1/login/vali-login', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 获取用户区号
export const customerCode = async function (lang) {
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.get('/?r=v1/user/nation-code&lang=' + lang).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 生成二维码接口
export const buildQrCode = async function (project) {
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.get('/?r=v1/user/qr-code&project=' + project).then(
                (res) => { resolve(res) },
                (err) => { reject(err) })
        })
    }
    const result = await validRes()
    return result
}

// 获取login凭证的接口

// 监听二维码状态
export const webListener = async function (loginKey) {
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post(
                '/?r=v1/user/qr-state', qs.stringify({ key: loginKey })
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 二维码方式登录发送登录请求
export const webLogin = async function (mobile, token, nationcode) {
    const validRes = function () {
        return new Promise(function (resolve, reject) {
            axios.post('/?r=v1/login/qlogin', qs.stringify({
                mobile: mobile,
                loginToken: token,
                nationCode: isNaN(nationcode) ? 86 : nationcode
            })).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    const result = await validRes()
    return result
}

// 记住账户
export const setCookie = function (account, exdays) {
    var d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    var expires = 'expires=' + d.toGMTString()
    document.cookie = 'username=' + account.username + ';expires=' + expires
    document.cookie = 'password=' + Base64.encode('Key&' + account.password) + ';expires=' + expires
}

// 读取账户
export const getCookie = function () {
    const account = {}
    var name = 'username='
    var pass = 'password='
    var cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim()
        if (c.indexOf(name) === 0) {
            account['username'] = c.substring(name.length, c.length)
        }
        if (c.indexOf(pass) === 0) {
            var domainString = Base64.decode(c.substring(pass.length, c.length))
            var baseArr = domainString.split('&')
            account['password'] = baseArr[1]
        }
    }
    return account
}

// 删除账户
export const rmCookie = function () {
    document.cookie = 'username=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    document.cookie = 'password=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
}

export default axios



//////////////////
// WEBPACK FOOTER
// ./api/login.js
// module id = dnp3
// module chunks = 0